<template>


  <div class="card-519 ">

    <div class="text-center ">
      <img class="img-fluid card-519-img w-100  " :src="image" :alt="alt">
    </div>

  </div>


</template>


<script>
import mA from "../Tags/A.vue";
import mImg from "../Tags/Img.vue";
import {CardProps} from "./CardProps";

export default {
  name: "Card519",
  components: {mA, mImg},
  props: {
    ...CardProps,
  }
}
</script>


<style scoped>
.card-519 {




}
.card-519-img{
  aspect-ratio: 1/1;
  object-fit: contain !important;
}



</style>
